var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"pointer",attrs:{"title":_vm.$t('global.click_to_expand')},domProps:{"innerHTML":_vm._s(_vm.results)},on:{"click":function($event){_vm.expand = !_vm.expand}}})
}
var staticRenderFns = []

export { render, staticRenderFns }